// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3a6ad801","558":"3a5c9557"}[chunkId] + ".chunk.js";
};